(function () {
  document.addEventListener("scroll", function () {
    //The animations only need to be applied if the parallax section is in desktop mode, returning here mobile
    //saves power.
    if (window.innerWidth <= 800) {
      return;
    }

    var scrollPosition = window.scrollY;
    var windowHeight = window.innerHeight;
    var viewportBottom = 0.6 * windowHeight; //40% from the bottom of the screen is our threshhold for triggering animations

    var images = document.querySelectorAll(
      ".sticky-parallax .sticky-wrapper .image"
    );
    var rightItems = document.querySelectorAll(".sticky-parallax .right-item");
    var container = document.querySelector(
      ".sticky-parallax .right-items-container"
    );

    // Calculate the start and end scroll positions for the container
    var containerStart = container.offsetTop;
    var containerHeight = container.offsetHeight;

    var containerEnd = containerStart + containerHeight * 2.0;
    var firstTriggerPoint =
      containerHeight / images.length + windowHeight * 0.5;

    if (scrollPosition < firstTriggerPoint) {
      // above the container
      images.forEach((img, index) => {
        if (index !== 0) {
          img[index].style.opacity = 0;
          rightItems[index].classList.add("inactive");
          rightItems[index].classList.remove("active");
        } else {
          images[index].style.opacity = 1;
          rightItems[index].classList.add("active");
          rightItems[index].classList.remove("inactive");
        }
      });
    } else if (scrollPosition > containerEnd) {
      // Below the container
      images.forEach((img, index) => {
        if (index !== images.length - 1) {
          img.style.opacity = 0;
          rightItems[index].classList.add("inactive");
          rightItems[index].classList.remove("active");
        } else {
          images[index].style.opacity = 1;
          rightItems[index].classList.add("active");
          rightItems[index].classList.remove("inactive");
        }
      });
    } else {
      rightItems.forEach(function (item, index) {
        var itemRect = item.getBoundingClientRect();
        var itemTop = itemRect.top;

        if (itemTop <= viewportBottom) {
          images.forEach((img, idx) => {
            if (idx !== index) {
              img.style.opacity = 0;
              rightItems[idx].classList.add("inactive");
              rightItems[idx].classList.remove("active");
            } else {
              img.style.opacity = 1;
            }
          });
          item.classList.add("active");
          item.classList.remove("inactive");
        }
      });
    }
  });
})();
